import { optional, z } from "zod";

export const DisciplinaArquivoSchema = z.object({
  IdDisciplina: z.number().optional(),
  idProjeto: z.number().nullable().optional(),
  descricao: z.string(),
  arquivo: z.instanceof(File).optional().nullable(),
  nome: z.string().optional().nullable(),
  arquivo2: z.instanceof(File).optional().nullable(),
  nome2: z.string().optional().nullable(),
  limparArquivo1: z.boolean().optional(),
  limparArquivo2: z.boolean().optional(),
});

export type DisciplinaArquivoForm = z.infer<typeof DisciplinaArquivoSchema>;
